/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Add_SaveInputs */



/**
* | output |
* | --- |
* | "Add" |
*
* @param {Meeting_Prep_Add_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_add_save = /** @type {((inputs?: Meeting_Prep_Add_SaveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Add_SaveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter")
	return /** @type {LocalizedString} */ ("Add")
});